import { render, staticRenderFns } from "./AddItemModal.vue?vue&type=template&id=2a09a7df&scoped=true&"
import script from "./AddItemModal.vue?vue&type=script&lang=js&"
export * from "./AddItemModal.vue?vue&type=script&lang=js&"
import style0 from "./AddItemModal.vue?vue&type=style&index=0&id=2a09a7df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a09a7df",
  null
  
)

export default component.exports